import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgChestGlyphSecondary from './svgs/ChestGlyphSecondary.js';
import SvgChestGlyph from './svgs/ChestGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var chestGlyph = (props => useIcon(SvgChestGlyph, SvgChestGlyphSecondary, props));

export { chestGlyph as default };
